export const visit = (vm, at) => {
vm(require("timezone-utils/lang/de.lyaml"));
vm(require("ui-addon-i18n/lang/de.lyaml"));
vm(require("UIComponents/lang/de.lyaml"));
vm(require("MeetingsLib/lang/de.lyaml"));
vm(require("sanitize-text/lang/de.lyaml"));
vm(require("I18n/lang/de.lyaml"));
at({ "de": { "placeholderString": "Meetings" } });
};